import { useTranslation } from 'next-i18next';

import styles from './NoSearchResults.module.scss';

const NoSearchResults = () => {
  const [t] = useTranslation('search.results');
  return (
    <div className={styles.container}>
      <p className={styles.emoji}>🙁</p>
      <p className={styles.message}>{t('opportunity-page.no-results')}</p>
    </div>
  );
};

NoSearchResults.displayName = 'NoSearchResults';

export default NoSearchResults;
